import { Umfrage } from "@/models/UmfrageModels"

export type State = {
  umfragen: Array<Umfrage>
}

export const state: State = {
  umfragen: sessionStorage.getItem("umfragen") != null ? JSON.parse(sessionStorage.umfragen) : new Array<Umfrage>(),
}
